import { useTranslation } from "react-i18next";

export default function MapSection() {
  const { t } = useTranslation("global");

  return (
    <div className="bg-white min-h-screen flex items-center">
      <section
        id="flyxom"
        className="w-full flex flex-col md:flex-row items-center py-12 md:py-20"
      >
        <div className="md:w-1/2 md:order-1 px-4">
          <div className="flex justify-center md:justify-center">
            <div className="flyxom-text text-center md:text-center md:mx-auto md:pr-6 lg:pr-10 md:pl-6 lg:pl-10">
              <h2 className="text-3xl font-semibold">{t("WIF.text")}</h2>
              <p className="text-base md:text-lg pt-4 pb-4 pl-4 pr-4 md:pb-0 ">
                {t("WIF2.text")}
                <span className="text-[#fcab22] font-bold">
                  {" "}
                  {t("WIF2_1.text")} {""}
                </span>
                {t("WIF2_2.text")}
                <span className="text-[#fcab22] font-bold">
                  {" "}
                  {t("WIF2_3.text")}
                </span>{" "}
                {t("WIF2_4.text")}
              </p>
            </div>
          </div>
        </div>
        <div className="md:w-1/2 md:order-2 pt-8 md:pt-0 px-4">
          <div className="flex justify-center md:justify-end">
            <img
              src={
                new URL(
                  "../../assets/images/mapa-responsive.png",
                  import.meta.url
                ).href
              }
              alt="Map Image"
              className="max-w-full h-auto block"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
